import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortedProperty',
})
export class SortPropertyPipe implements PipeTransform {
  transform(items: any[], property: string): any[] {
    const sortItems = [...items];
    sortItems.sort((a, b) => {
      if (!a[property] && !b[property]) {
        return 0;
      }
      if (!a[property]) {
        return 1;
      }
      if (!b[property]) {
        return -1;
      }
      return a[property].localeCompare(b[property]);
    });
    return sortItems;
  }
}
